import * as React from 'react';

import { type SlateElementProps, SlateElement } from '@udecode/plate';

export function CodeLineElementStatic(props: SlateElementProps) {
  return <SlateElement {...props} />;
}
